import { Injectable } from '@angular/core';
import { getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';
@Injectable({
  providedIn: 'root'
})
export class ParametrizacionService {

  PILOTO_DIGITAL_GET: string = getEndpoint("PILOTO_DIGITAL_GET")
  PILOTO_DIGITAL_SET: string = getEndpoint("PILOTO_DIGITAL_SET")
  PILOTO_DIGITAL_ORIGENES: string = getEndpoint("PILOTO_DIGITAL_ORIGENES")

  constructor(private requestsService: RequestsService) { }

  async getPilotos() {
    return await this.requestsService.get(this.PILOTO_DIGITAL_GET)
  }

  async setPilotos(params) {
    return await this.requestsService.postLikeJSON(this.PILOTO_DIGITAL_SET, params)
  }

  async getOrigenes() {
    return await this.requestsService.get(this.PILOTO_DIGITAL_ORIGENES)
  }

}
